/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Upload = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="upload" />;

export { Upload, Upload as default };
